import { useEffect, useRef, useState } from "react";

const SelectInput = ({
  label,
  value,
  onChange,
  options = [],
  disabled = false,
  placeholder = "-- Select --",
  className = "",
}) => {
  const [open, setOpen] = useState(false);
  const selectedOption = options.find((opt) => opt.value === value);
  const dropdownRef = useRef(null);
 
  useEffect(() => {
    const handleClickOutSide = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutSide);
    return () => {
      document.removeEventListener("mousedown", handleClickOutSide);
    };
  }, [open]);

  return (
    <div className={`relative mb-3 ${className}  `} ref={dropdownRef}>
      {label && (
        <label className="block mb-1 font-medium text-gray-700">{label}</label>
      )}

      <div
        className={`border border-gray-300 px-3 py-2 rounded w-full bg-white cursor-pointer ${
          disabled ? "opacity-50 pointer-events-none" : ""
        }`}
        onClick={() => setOpen(!open)}
      >
        {selectedOption ? selectedOption.label : placeholder}
      </div>

      {open && (
  <>
    {label !== "Class" ? (
      <ol
        type="1"
        className="absolute z-10 w-full mt-1 border rounded bg-white shadow h-[320px] overflow-y-auto list-decimal list-inside max-h-40 "
      >
        {options.map(({ value, label }) => (
          <li
            key={value}
            className="p-2 hover:bg-gray-100 cursor-pointer select-text"
            onClick={() => {
              onChange({ target: { value } });
              setOpen(false);
            }}
          >
            {label}
          </li>
        ))}
      </ol>
    ) : (
              <ul
        className="absolute z-10 w-full mt-1 border rounded bg-white shadow h-[320px] overflow-y-auto  list-inside"
      >
        {options.map(({ value, label }) => (
          <li
            key={value}
            className="p-2 hover:bg-gray-100 cursor-pointer select-text"
            onClick={() => {
              onChange({ target: { value } });
              setOpen(false);
            }}
          >
            {label}
          </li>
        ))}
      </ul>
    )}
  </>
)}

    </div>
  );
};

export default SelectInput;
